import React, { useState, Fragment, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import { getFormsAxios, getListingsAxios, getSocialLinkAxios } from "../../Actions/axios";
import { Form, Nav } from "react-bootstrap";



const Viewformlists = () => {

    const navigate = useNavigate();
    //   const [cointokenList, setCointokenList] = useState([]);
    const location = useLocation();
    const { goBackSectionType } = location.state || "exchange";
    console.log("goBackSectionType", goBackSectionType)
    const [sectiontype, setSectiontype] = useState("");
    console.log("FSectionTypesss", sectiontype)
    const Formtypes = [
        { label: "Exchange", value: "exchange" },
        { label: "CoinToken", value: "coin" }
    ]
    const [FormLists, setFormLists] = useState([]);
    console.log("exchangeListsexchangeLists", FormLists);

    const getFormListsList = async (type) => {
        console.log("typepepepepep", type)
        const sectionType = type ? type : goBackSectionType ? goBackSectionType : "exchange";
        setSectiontype(sectionType)
        let resp = await getFormsAxios({ section: sectionType ? sectionType : {} });
        console.log("🚀 ~ FormLists ~ resp:", resp);
        if (resp?.status) {
            setFormLists(resp?.data?.data);
        }
    };


    const columns = [
        {
            name: "S.No",
            align: "left",
            sortable: false,
            //   selector: (row) => row.title,
            cell: (record,index) => {
                return (
                    <Fragment>
                        <p>{index+1}</p>
                    </Fragment>
                );
            },
        },
        {
            name: "Email",
            align: "left",
            sortable: false,
            //   selector: (row) => row.title,
            cell: (record) => {
                return (
                    <Fragment>
                        <p>{record?.email}</p>
                    </Fragment>
                );
            },
        },
        {
            name: "Type",
            align: "left",
            sortable: false,
            //   selector: (row) => row.title,
            cell: (record) => {
                return (
                    <Fragment>
                        <p>{record?.section}</p>
                    </Fragment>
                );
            },
        },
        {
            name: "Status",
            align: "left",
            sortable: false,
            //   selector: (row) => row.title,
            cell: (record) => {
                return (
                    <Fragment>
                        <p>{record?.status}</p>
                    </Fragment>
                );
            },
        },
        {
            name: "Action",
            align: "left",
            sortable: false,
            cell: (record) => {
                return (
                    <Fragment>
                        <button
                            className={`btn sitebtn btn-sm`}
                            onClick={() => navigate("/ViewForm", {
                                state: {
                                    records: record,
                                    sectionType: sectiontype
                                },
                            })}
                        >
                            <FaEdit />
                        </button>
                    </Fragment>
                );
            },
        },
    ];


    useEffect(() => {
        getFormListsList();
    }, []);

    return (

        <div className="cmslist">
            <h1 className="pagehead">Form Lists</h1>
            <div className="cardbox">
                {/*  <Form.Select
                    onChange={(e) => getFormListsList(e.target.value)}
                    id="type"
                    value={sectiontype || ""}
                >
                    <option value="" disabled>Choose Question Type</option>
                    <option value="exchange">Exchange</option>
                    <option value="coin">Coin</option>
                </Form.Select> */}

                <div className="d-flex align-items-center justify-content-end gap-3 mb-4">
                    <Nav variant="pills" className="custom_table_tabs"
                    // activeKey={activeTab}
                    >
                        {
                            Formtypes.map((item, index) => (
                                <>
                                    {console.log("itemds", item.value)}
                                    <Nav.Item key={index}>
                                        <Nav.Link eventKey={`tab-${index}`} onClick={() => { getFormListsList((item?.value).toString()) }}><span>{item?.label}</span></Nav.Link>
                                    </Nav.Item>
                                </>))
                        }
                    </Nav>
                </div>
                <div className="tablebox">
                    <DataTable
                        className="react-datatables"
                        columns={columns}
                        data={FormLists}
                        pagination
                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                    />
                </div>
            </div>
        </div>
    );
};

export default Viewformlists;